import React, { useState } from "react";
import { CloseIcon } from "../../Common/SvgIcons/WorkflowIcons";
import { formatConfigLabel } from "./experimentConfigDisplayUtils";

function displayClassName(label) {
  return formatConfigLabel(label);
}

export default function ClassLabelsPreview({
  classNames,
  maxVisible = 3,
  variant = "text",
  expandMode = "inline",
  className = "",
}) {
  const [expanded, setExpanded] = useState(false);
  const [showModal, setShowModal] = useState(false);

  if (!Array.isArray(classNames) || !classNames.length) {
    return <span className={className}>-</span>;
  }

  const hasHidden = classNames.length > maxVisible;
  const hiddenCount = classNames.length - maxVisible;
  const isPopupMode = expandMode === "popup";
  const displayedLabels =
    !hasHidden || isPopupMode
      ? classNames.slice(0, maxVisible)
      : expanded
        ? classNames
        : classNames.slice(0, maxVisible);

  const handleMoreClick = (event) => {
    event.stopPropagation();
    if (isPopupMode) {
      setShowModal(true);
      return;
    }
    setExpanded(true);
  };

  const handleShowLess = (event) => {
    event.stopPropagation();
    setExpanded(false);
  };

  const moreButton =
    hasHidden && (isPopupMode || !expanded) ? (
      <button
        type="button"
        className={
          variant === "chips"
            ? "training-config-chip training-config-chip--more"
            : variant === "comparison"
              ? "training-comparison-classes__more"
              : variant === "config"
                ? "training-config-classes__more"
                : "training-class-labels-more"
        }
        onClick={handleMoreClick}
      >
        +{hiddenCount} more
      </button>
    ) : null;

  const showLessButton =
    !isPopupMode && expanded && hasHidden ? (
      <button
        type="button"
        className={
          variant === "chips"
            ? "training-config-chip training-config-chip--more"
            : variant === "comparison"
              ? "training-comparison-classes__more"
              : variant === "config"
                ? "training-config-classes__more"
                : "training-class-labels-more"
        }
        onClick={handleShowLess}
      >
        Show less
      </button>
    ) : null;

  const modal = showModal ? (
    <div
      className="training-class-labels-modal-overlay"
      onClick={() => setShowModal(false)}
    >
      <div
        className="training-class-labels-modal container-card"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="All class labels"
      >
        <div className="training-class-labels-modal__header">
          <h5 className="mb-0">All classes</h5>
          <button
            type="button"
            className="plain-button2 text-danger p-0"
            onClick={() => setShowModal(false)}
            aria-label="Close class list"
          >
            <CloseIcon className="wf-icon text-secondary-small" />
          </button>
        </div>
        <div className="training-class-labels-modal__body">
          {classNames.map((label) => (
            <span key={label} className="training-class-labels-chip" title={label}>
              {displayClassName(label)}
            </span>
          ))}
        </div>
      </div>
    </div>
  ) : null;

  if (variant === "config" || variant === "comparison") {
    const containerClass =
      variant === "comparison"
        ? `training-comparison-classes${expanded ? " training-comparison-classes--expanded" : ""} ${className}`.trim()
        : `training-config-classes${expanded ? " training-config-classes--expanded" : ""} ${className}`.trim();
    const tagClass =
      variant === "comparison"
        ? "training-comparison-classes__tag"
        : "training-config-classes__tag";
    const previewClass =
      variant === "comparison"
        ? "training-comparison-classes__preview"
        : "training-config-classes__preview";
    const moreClass =
      variant === "comparison"
        ? "training-comparison-classes__more"
        : "training-config-classes__more";
    const labelsToShow = expanded || !hasHidden ? classNames : classNames.slice(0, maxVisible);

    return (
      <div className={containerClass}>
        <div className={previewClass}>
          {labelsToShow.map((label) => (
            <span key={label} className={tagClass} title={label}>
              {displayClassName(label)}
            </span>
          ))}
          {hasHidden && !expanded ? (
            <button type="button" className={moreClass} onClick={handleMoreClick}>
              +{hiddenCount} more
            </button>
          ) : null}
          {hasHidden && expanded ? (
            <button type="button" className={moreClass} onClick={handleShowLess}>
              Show less
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  if (variant === "chips") {
    return (
      <>
        <div className={`training-config-chip-list training-config-chip-list--class ${className}`.trim()}>
          {displayedLabels.map((label) => (
            <span key={label} className="training-config-chip" title={label}>
              {displayClassName(label)}
            </span>
          ))}
          {moreButton}
          {showLessButton}
        </div>
        {modal}
      </>
    );
  }

  return (
    <>
      <span className={className}>
        {displayedLabels.map(displayClassName).join(", ")}
        {moreButton ? (
          <>
            {displayedLabels.length ? ", " : null}
            {moreButton}
          </>
        ) : null}
        {showLessButton}
      </span>
      {modal}
    </>
  );
}
